import { render, staticRenderFns } from "./Company-information-card.vue?vue&type=template&id=4283ce99&scoped=true"
import script from "./Company-information-card.vue?vue&type=script&lang=js"
export * from "./Company-information-card.vue?vue&type=script&lang=js"
import style0 from "./Company-information-card.vue?vue&type=style&index=0&id=4283ce99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4283ce99",
  null
  
)

export default component.exports